import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "./store/actions/auth";
import "semantic-ui-css/semantic.min.css";

import HomepageLayout from "./containers/Home";
import LoginForm from "./containers/Login";
import RegistrationForm from "./containers/Signup";
import CustomLayout from "./containers/Layout";

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    return (
      <Router>
        <CustomLayout {...this.props}>
          <Routes>
            <Route path="/" element={<HomepageLayout />} />
            <Route path="" element={<HomepageLayout />} />
            <Route path="/login" element={<LoginForm />} />
            <Route path="/signup" element={<RegistrationForm />} />
          </Routes>
        </CustomLayout>
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.token !== null,
});

const mapDispatchToProps = (dispatch) => ({
  onTryAutoSignup: () => dispatch(actions.authCheckState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);